"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const styles_1 = require("@mui/styles");
const react_1 = __importDefault(require("react"));
const useStyles = (0, styles_1.makeStyles)(() => ({
    box: {
        position: "relative",
        right: 0,
        left: 0,
        marginTop: "-95px",
    },
}));
function Actions({ children, p, spacing, }) {
    const classes = useStyles();
    return (react_1.default.createElement(material_1.Box, { p: p || 8, className: classes.box },
        react_1.default.createElement(material_1.Grid, { container: true, spacing: spacing || 4 }, children)));
}
exports.default = Actions;
